class ImmutableSet {
  constructor() {
    let elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this._elements = [];
    this._map = {};
    if (!Array.isArray(elements)) {
      elements = [elements];
    }
    elements.forEach(element => {
      if (!this.contains(element)) {
        this._elements.push(element);
        this._map[JSON.stringify(element)] = this._elements.length - 1;
      }
    });
  }
  contains(value) {
    return this._map[JSON.stringify(value)] !== undefined;
  }
  containsAll(elements) {
    return elements.every(element => this.contains(element));
  }
  add(value) {
    if (this.contains(value)) {
      return this;
    }
    return new ImmutableSet(this._elements.concat([value]));
  }
  remove(value) {
    const index = this._map[JSON.stringify(value)];
    if (index === undefined) {
      return this;
    }
    const elements = this._elements.slice();
    elements.splice(index, 1);
    return new ImmutableSet(elements);
  }
  union() {
    let elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(elements)) {
      elements = [elements];
    }
    if (elements.length === 0) {
      return this;
    }
    return new ImmutableSet(this._elements.concat(elements));
  }
  subtract() {
    let elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!Array.isArray(elements)) {
      elements = [elements];
    }
    if (elements.length === 0) {
      return this;
    }
    return new ImmutableSet(this._elements.filter(element => !elements.includes(element)));
  }
  get elements() {
    return this._elements.slice();
  }
}
export default ImmutableSet;